import React from 'react';
import Bg_Image from '../../assets/images/footer-bg.jpg';
import ScrollSnapBox from "../ScrollSnapBox";

const GradientText = () => {
 return (
   <ScrollSnapBox>
     {({inView}) => (
       <div className="px-6 sm:px-8 md:px-10 lg:px-20"
         style={{
           opacity: inView ? 1 : 0,
           transform: `translateY(${inView ? '0' : '30px'})`,
           transition: 'all 1000ms ease-out'
         }}>
         <div className="relative w-full h-[120px] flex items-center justify-center py-2">
           <h2 
             className="text-4xl lg:text-6xl font-bold leading-tight text-center"
             style={{
               backgroundImage: `url(${Bg_Image})`,
               WebkitBackgroundClip: 'text',
               backgroundClip: 'text',  
               backgroundRepeat: 'no-repeat',  
               WebkitTextFillColor: 'transparent', 
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               animation: inView ? 'revealGradient 2s ease-in-out forwards' : 'none'
             }}
           >
             Hydrogen for Green Planet
           </h2>
           <style jsx>{`
              @keyframes revealGradient {
                0% {
                  -webkit-mask-image: linear-gradient(to right, transparent 48%, black 50%, transparent 52%);
                  mask-image: linear-gradient(to right, transparent 48%, black 50%, transparent 52%);
                }
                10% {
                  -webkit-mask-image: linear-gradient(to right, transparent 45%, black 50%, transparent 55%);
                  mask-image: linear-gradient(to right, transparent 45%, black 50%, transparent 55%);
                }
                20% {
                  -webkit-mask-image: linear-gradient(to right, transparent 40%, black 50%, transparent 60%);
                  mask-image: linear-gradient(to right, transparent 40%, black 50%, transparent 60%);
                }
                30% {
                  -webkit-mask-image: linear-gradient(to right, transparent 35%, black 50%, transparent 65%);
                  mask-image: linear-gradient(to right, transparent 35%, black 50%, transparent 65%);
                }
                40% {
                  -webkit-mask-image: linear-gradient(to right, transparent 30%, black 50%, transparent 70%);
                  mask-image: linear-gradient(to right, transparent 30%, black 50%, transparent 70%);
                }
                50% {
                  -webkit-mask-image: linear-gradient(to right, transparent 25%, black 50%, transparent 75%);
                  mask-image: linear-gradient(to right, transparent 25%, black 50%, transparent 75%);
                }
                60% {
                  -webkit-mask-image: linear-gradient(to right, transparent 20%, black 50%, transparent 80%);
                  mask-image: linear-gradient(to right, transparent 20%, black 50%, transparent 80%);
                }
                70% {
                  -webkit-mask-image: linear-gradient(to right, transparent 15%, black 50%, transparent 85%);
                  mask-image: linear-gradient(to right, transparent 15%, black 50%, transparent 85%);
                }
                80% {
                  -webkit-mask-image: linear-gradient(to right, transparent 10%, black 50%, transparent 90%);
                  mask-image: linear-gradient(to right, transparent 10%, black 50%, transparent 90%);
                }
                90% {
                  -webkit-mask-image: linear-gradient(to right, transparent 5%, black 50%, transparent 95%);
                  mask-image: linear-gradient(to right, transparent 5%, black 50%, transparent 95%);
                }
                100% {
                  -webkit-mask-image: linear-gradient(to right, black 0%, black 100%);
                  mask-image: linear-gradient(to right, black 0%, black 100%);
                }
              }
            `}</style>
         </div>
       </div>
     )}
   </ScrollSnapBox>
 );
};

export default GradientText;